<p-blockUI [blocked]="blocked">
  <p-progressSpinner></p-progressSpinner>
</p-blockUI>

<div class="grid fluid">
  <div class="col-6 sm:col-6">
    <app-departmentselector labelKey="Отдел - поставщик" [parentCompany]="newDocument.DOCMANCLIID" [selectedID]="newDocument.DOCMANDEPID" (selectedDepartmentID)="stock1Selected($event)"></app-departmentselector>
  </div>
  <div class="col-6 sm:col-6">
    <app-departmentselector labelKey="Отдел - получатель" [parentCompany]="newDocument.DOCMANCLIID" [selectedID]="newDocument.DOCCLIDEPID" (selectedDepartmentID)="stock2Selected($event)"></app-departmentselector>
  </div>
</div>
<div class="grid fluid">
  <div class="col-12 mt-2">
    <p-checkbox [(ngModel)]="doNotCheckSource" [binary]="true" (onChange)="onProductionMode($event)" label="Не проверять наличие на складе-поставщике"></p-checkbox>
  </div>
</div>
